var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7743 9.65784L13.4439 10.6108L14.4741 9.86388V15.2724H15.5815V8.16407H14.6544L12.7743 9.65784Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 11.5114C11.4101 11.1508 11.6676 10.61 11.6676 10.0434C11.6676 8.91015 10.6632 7.98298 9.45271 7.98298C8.42252 7.98298 7.5211 8.62685 7.28931 9.57978L8.37101 9.86308C8.47403 9.42525 8.93762 9.11619 9.45271 9.11619C10.0708 9.11619 10.5602 9.52826 10.5602 10.0434C10.5602 10.5585 10.0708 10.9705 9.45271 10.9705H8.80884V12.1037H9.45271C10.1481 12.1037 10.7405 12.5931 10.7405 13.1597C10.7405 13.7521 10.1738 14.2156 9.47847 14.2156C8.86035 14.2156 8.3195 13.8293 8.24224 13.2885L7.16054 13.4687C7.34082 14.5247 8.34526 15.3231 9.50422 15.3231C10.8177 15.3231 11.8737 14.3444 11.8737 13.1339C11.8479 12.4901 11.5131 11.8977 10.998 11.5114Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1817 23.3333H5.20126V18.1566H18.1817V23.3333Z",
    fill: "#FBC02D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3585 18.1565V5.17611H18.1818V18.1565H23.3585Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1829 5.17671V0H1.95736C0.875663 0 0 0.875662 0 1.95736V18.1829H5.17671V5.17671H18.1829Z",
    fill: "#1E88E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 18.1566V23.3333L23.3585 18.1566H18.1818Z",
    fill: "#E53935"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4269 1.90735e-06H18.1818V5.17671H23.3585V1.93161C23.3585 0.84991 22.5086 1.90735e-06 21.4269 1.90735e-06Z",
    fill: "#1565C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95676 23.3333H5.20186V18.1566H0.0251522V21.4017C0.0251522 22.4834 0.87506 23.3333 1.95676 23.3333Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google_calendar.c5048e160cf1d2feea0a63d3c018574c.svg";
export { ForwardRef as ReactComponent };